import React from "react";
import { Contacts } from "../components/contacts/Contacts";
const Page = () => {
  return <Contacts />;
};

export default Page;
